import React from 'react'
import { Tooltip, TooltipProps } from '@node-space/ui-components'

export interface ConditionalTooltipProps extends TooltipProps {
  isEnabled: boolean
}

export const ConditionalTooltip = ({ isEnabled, children, ...props }: ConditionalTooltipProps) => {
  if (!isEnabled) return children
  return <Tooltip {...props}>{children}</Tooltip>
}
